import axios from "axios";
import { handleSuccessOne, handleErrorOne } from "@store/action/GlobalAction";

const API = process.env.REACT_APP_MICRO_SMART_URL;
const VERSION = process.env.REACT_APP_MICRO_SMART_URL_API;
const radio_id = localStorage.getItem("radio_id");

export const getTopicPublicity = (params) => (dispatch) => {
  axios.get(`${API}${VERSION}/Products/topics`, { params }).then((response) => {
    dispatch({
      type: "GET_TOPIC_PUBLICITY",
      data: response.data.data.topicsList,
    });
  });
};
export const getTopicNews = (params) => (dispatch) => {
  axios.get(`${API}${VERSION}/News/topics`, { params }).then((response) => {
    dispatch({
      type: "GET_TOPIC_NEWS",
      data: response.data.data.topicsList,
    });
  });
};
export const getTopic = (webmasterTitle, params) => (dispatch) => {
  params.dir = "Desc";
  params.find_q = params.find_q?.slice(1).split("&")[0].split("=")[1];
  axios
    .get(`${API}${VERSION}/${webmasterTitle}/topics`, {
      params,
    })
    .then((response) => {
      dispatch({
        type: "GET_NEWS",
        data: response.data.data.topicsList,
        allData: response.data.data.topicsList,
        totalPages: response.data.data.topicsList.total,
        params,
      });
    });
};
export const getBlogByid = (webmasterTitle, id) => (dispatch) => {
  axios
    .get(`${API}${VERSION}/${webmasterTitle}/topics/${id}`)
    .then((response) => {
      dispatch({
        type: "GET_NEWS_ID",
        data: response.data.data,
        photo: response.data.data,
      });
    });
};
export const getTopicByUser =
  (webmasterTitle, user_id, params) => (dispatch) => {
    axios
      .get(`${API}${VERSION}/${webmasterTitle}/createdby/topics/${user_id}`, {
        params,
      })
      .then((response) => {
        dispatch({
          type: "GET_TOPIC_BY_USER",
          data: response.data.data.topicsList,
          totalPages: response.data.data.topicsList.total,
          params,
        });
      });
  };
export const createTopicWithEditor =
  (webmasterTitle, data, gallery, setProgressUpload) => (dispatch) => {
    dispatch({
      type: "UPLOAD_IS_LOADING",
    });
    data.radio_id = parseInt(radio_id);

    const formData = new FormData();
    formData.append("title", data.title);
    formData.append("details", data.details);
    formData.append("date", data.date);
    formData.append("radio_id", radio_id);
    formData.append("created_by", data.created_by);
    data.section_id && formData.append("section_id", data.section_id);

    {
      data.video_file && formData.append("video_file", data.video_file);
    }
    {
      data.cover && formData.append("cover", data.cover);
    }
    // formData.append("icon", data.icon);
    for (let i = 0; i < gallery.length; i++) {
      formData.append("gallery_photo_file[]", gallery[i]);
    }
    const config = {
      onUploadProgress: (progressEvent) => {
        let { loaded, total } = progressEvent;
        let percentComplete = loaded / total;
        percentComplete = parseInt(percentComplete * 100);
        setProgressUpload(percentComplete);
      },
    };

    axios
      .post(`${API}${VERSION}/${webmasterTitle}/topics`, formData, config)
      .then((res) => {
        dispatch({
          type: "UPLOAD_FINISHED_LOADING",
        });
        dispatch({
          type: "ADD_NEWS_SUCCESS",
          payload: res.data,
        });
        handleSuccessOne(res.data.message, () => {
          window.location.assign(`/admin/${webmasterTitle}/topics`);
        });
        dispatch(getTopic(`${webmasterTitle}`));
      })
      .catch((err) => {
        if (err.response) {
          dispatch({
            type: "UPLOAD_FINISHED_LOADING",
          });
          dispatch({
            type: "ADD_NEWS_FAIL",
            payload: err.response.data.message,
          });
          setTimeout(() => {
            dispatch({
              type: "ADD_NEWS_FAIL",
              payload: null,
            });
          }, 3000);
        }
      })
      .finally(() => {
        setProgressUpload(-1);
      });
  };
export const editTopic =
  (webmasterTitle, data, gallery, setProgressUpload) => (dispatch) => {
    dispatch({
      type: "UPLOAD_IS_LOADING",
    });
    const formData = new FormData();
    formData.append("title", data.title);
    formData.append("details", data.details);
    formData.append("date", data.date);
    formData.append("radio_id", radio_id);
    data.section_id && formData.append("section_id", data.section_id);
    {
      data.photo_file && formData.append("cover", data.photo_file);
    }
    {
      data.video_file && formData.append("video_file", data.video_file);
    }
    formData.append("_method", data._method);
    formData.append("icon", data.icon);
    for (let i = 0; i < gallery.length; i++) {
      formData.append("gallery_photo_file[]", gallery[i]);
    }
    for (let i = 0; i < data.deletedImg.length; i++) {
      formData.append("photo_id_to_delete[]", data.deletedImg[i]);
    }
    const config = {
      onUploadProgress: (progressEvent) => {
        let { loaded, total } = progressEvent;
        let percentComplete = loaded / total;
        percentComplete = parseInt(percentComplete * 100);
        setProgressUpload(percentComplete);
      },
    };
    axios
      .post(
        `${API}${VERSION}/${webmasterTitle}/topics/${data.id}`,
        formData,
        config
      )
      .then((response) => {
        dispatch({
          type: "UPLOAD_FINISHED_LOADING",
        });
        dispatch({
          type: "EDIT_NEWS_SUCCESS",
          payload: response.data,
        });
        handleSuccessOne(response.data.message, () => {
          window.location.assign(`/admin/${webmasterTitle}/topics`);
        });
        dispatch(getTopic(webmasterTitle));
      })
      .catch((err) => {
        if (err.response) {
          dispatch({
            type: "EDIT_NEWS_FAIL",
            payload: err.response.data.message,
          });
          setTimeout(() => {
            dispatch({
              type: "EDIT_NEWS_FAIL",
              payload: null,
            });
          }, 3000);
        }
      })
      .finally(() => {
        setProgressUpload(-1);
      });
  };

export const deleteTopic =
  (webmasterTitle, id, refresh, status) => (dispatch) => {
    axios
      .delete(
        `${API}${VERSION}/${webmasterTitle}/topics/${id}?hard_delete=${status}`
      )
      .then((res) => {
        if (res.data.status === 200) {
          handleSuccessOne(res.data.message);
          refresh();
        }
      })
      .catch((err) => {
        if (err.response) {
          handleErrorOne(err.response.data.message);
        }
      });
  };

export const getSoftDeletedTopicsByRadio_id = (
  dispatch,
  topic_name,
  params
) => {
  axios
    .get(`${API}${VERSION}/${topic_name}/topics/deleted/list/radio`, {
      params: { per_page: params.per_page, page: params.page },
    })
    .then((res) => {
      dispatch({
        type: "GET_SOFT_DELETED_TOPICS",
        data: res.data.data[topic_name],
      });
    });
};
export const restoreTopic = (dispatch, topic_name, topic_id, params) => {
  axios
    .get(`${API}${VERSION}/${topic_name}/topics/restore/${topic_id}`)
    .then((res) => {
      getSoftDeletedTopicsByRadio_id(dispatch, topic_name, params);
      handleSuccessOne(res.data.message);
    })
    .catch((err) => {
      handleErrorOne("error on restore");
    });
};
